// Elegant, minimal decorative divider inspired by lotus / mandala motifs.
// Renders SVG only — no external assets — so it stays crisp at any width.
export default function MandalaDivider({ color = "#D4AF37", opacity = 0.65, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
      <span
        className="flex-1 h-px"
        style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)`, opacity }}
      />
      <svg width="52" height="24" viewBox="0 0 52 24" fill="none" style={{ opacity }}>
        <g stroke={color} strokeWidth="1.1" strokeLinecap="round" fill="none">
          {/* lotus */}
          <path d="M26 20 C 20 14 20 8 26 3" />
          <path d="M26 20 C 32 14 32 8 26 3" />
          <path d="M26 20 C 14 18 10 12 8 8" />
          <path d="M26 20 C 38 18 42 12 44 8" />
          <circle cx="26" cy="20" r="1.4" fill={color} stroke="none" />
        </g>
      </svg>
      <span
        className="flex-1 h-px"
        style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)`, opacity }}
      />
    </div>
  );
}
